<template>
  <div class="series">
    <!--5-1_シリーズ選択ページ-->
    <h1 class="series-title"><img :src="require(`@images/series/${$route.params.lang}/txt_series-${currentSeriesId}.png`)" :alt="textSeriesTitle"></h1>
    <swiper class="series-list" :options="swiperOption" ref="seriesSwiper">
      <swiper-slide v-for="(item, i) in seriesIdList" :key="i" class="item" :ref="`index-${i}`" :data-series-id="item.value">
        <img :src="packageImage(item.value)">
      </swiper-slide>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
    <div class="buttons">
      <div class="btn-back" @click="goToTop()">
        <img
          :src="require(`@images/series/${$route.params.lang}/text_back.png`)"
        >
      </div>
      <div class="btn-select" @click="goToHeroes()">
        <btn-blue><img :src="require(`@images/series/${$route.params.lang}/text_select-hero.png`)"></btn-blue>
      </div>
    </div>
    <window-box class="window-box">
      <p class="text" v-html="textSeriesDesc" />
    </window-box>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { seriesId } from '@constants'
import localeSeries from '@locales/series'
import BtnBlue from '@components/global/button-blue.vue'
import WindowBox from '@components/global/window-box-blue.vue'

export default {
  name: 'series',
  beforeRouteEnter (to, from, next) {
    if (!to.query.series) {
      next({ path: to.path, query: { series: seriesId.enums[0].value } })
    } else {
      next()
    }
  },
  $messages: localeSeries,
  components: {
    swiper,
    swiperSlide,
    BtnBlue,
    WindowBox,
  },
  data() {
    return {
      swiperOption: {
        loop: true,
        navigation: { 
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        init: false,
        initialSlide: 0,
        allowTouchMove: false,
        on: {
          slideChange: () => {
            const series = this.swiper ? seriesId.enums.find((s,i) => i === this.swiper.realIndex) : null
            if (series) {
              this.currentSeriesId = series.value
              this.$router.replace({query: {series: this.currentSeriesId}},() => {})
            }
          },
          init: () => {
            const initialSlide = seriesId.enums.map((s,i) => s.value === Number(this.$route.query.series) ? i : null).filter(s => s !== null)[0]
            this.swiper.slideTo(initialSlide + 1)
          },
        },
      },
      currentSeriesId: null,
    }
  },
  computed: {
    swiper() {
      return this.$refs.seriesSwiper ? this.$refs.seriesSwiper.swiper : null
    },
    seriesIdList() {
      return seriesId.enums
    },
    textSeriesTitle() {
      return this.$route.query.series ? this.$t(`game${this.$route.query.series}.title`) : null
    },
    textSeriesDesc() {
      return this.$route.query.series ? this.$t(`game${this.$route.query.series}.desc`) : null
    },
  },
  watch: {
    '$route.params.lang'(){
      //MEMO: swiper のslide画像が言語切り替えで変更できないスライドがあるので強制リロード
      location.reload()
    }
  },
  created(){
    if (this.$route.query.series) {
      this.currentSeriesId = this.$route.query.series
    }
  },
  mounted(){
    this.$refs.seriesSwiper.swiper.init()
  },
  methods: {
    packageImage(seriesId) {
      return require(`@images/series/${this.$route.params.lang}/img_series-${seriesId}.png`)
    },
    goToHeroes() {
      this.$router.push(`/${this.$route.params.lang}/series/${this.currentSeriesId}`)
      window.scrollTo(0, 0)
    },
    goToTop() {
      this.$router.push(`/${this.$route.params.lang}`)
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.series {
  width: 100%;
  margin-top: -8px;
  margin-bottom: 48px;
  padding-top: 220px;
  background-image: url(#{$img-path}series/bg_series.png);
  background-repeat: no-repeat;
  > .series-title {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 30px auto 0;
    width: 608px;
    height: 60px;
    background-image: url(#{$img-path}series/bg_title.png);
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-size: 608px auto;
    > * {
      position: relative;
      top: -3px;
    }
  }
  > .series-list {
      width: 100%;
      height: 420px;
      background-image: url(#{$img-path}series/bg_series-list.png);
      background-repeat: no-repeat;
      background-size: 100% auto;
      background-position: 0 50%;
    .item {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      transform: none;
      > img {
        display: block;
      }
    }
    .swiper-button-prev,
    .swiper-button-next {
      position: absolute;
      top: calc(50% - 80px);
      width: 127px;
      height: 208px;
      background-repeat: no-repeat;
      background-size: 100% auto;
      background-position: 50% 50%;
      @include tap-event();
      &:focus {
        outline: none;
      }
    }
    .swiper-button-prev {
      background-image: url(#{$img-path}series/arrow_left.png)
    }
    .swiper-button-next {
      background-image: url(#{$img-path}series/arrow_right.png)
    }
  }
  > .buttons {
    display: flex;
    align-items: center;
    justify-content: center;
    .btn-back {
      display: flex;
      align-items: flex-end;
      justify-content: center;
      width: 104px;
      height: 104px;
      background-image: url(#{$img-path}series/btn_back.png);
      background-repeat: no-repeat;
      background-position: 50% 50%;
      background-size: 100% auto;
      @include tap-event();
    }
    .btn-select {
      width: 490px;
      height: 102px;
      @include tap-event();
      margin-left: 7px;
    }
    .button-outer {
      padding: 0 61px;
    }
  }
  .window-box {
    margin-top: 30px;
  }
}

</style>